import { render, staticRenderFns } from "./UserRate.vue?vue&type=template&id=223558f5&scoped=true"
import script from "./UserRate.vue?vue&type=script&lang=js"
export * from "./UserRate.vue?vue&type=script&lang=js"
import style0 from "./UserRate.vue?vue&type=style&index=0&id=223558f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223558f5",
  null
  
)

export default component.exports